import tmhRequest from '@/config/tmhRequest'

export default {
    searchRating: function (data) {
        return tmhRequest({
            url: '/employee/tmh/rating/searchrating',
            method: 'post',
            params: data,
        })
    },
    searchRatingCount: function (data) {
        return tmhRequest({
            url: '/employee/tmh/rating/searchratingcount',
            method: 'post',
            data: data,
        })
    },

    searchRatingByPage: function (data) {
        return tmhRequest({
            url: '/employee/tmh/rating/searchratingbypage',
            method: 'post',
            data: data,
        })
    },

    
    addRateType: function (data) {
        return tmhRequest({
            url: '/employee/tmh/rating/addrating',
            method: 'post',
            params: data,
        })
    },

    editRating: function (data) {
        return tmhRequest({
            url: '/employee/tmh/rating/editrating',
            method: 'post',
            params: data,
        })
    },
    deleteRateType: function (data) {
        return tmhRequest({
            url: '/employee/tmh/rating/deleterating',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/employee/rating.js